<div [ngClass]="{ 'section-insert': true }">
   <ng-content></ng-content>
</div>
